<!--
// app/components/pages/region-matches-match-homeTeam-vs-awayTeam/MatchEventsLogosVs.vue
-->
<script setup lang="ts">
import type { Team } from "~/src/team/domain/models/Team";
import { setAliasUrl } from "~/src/Shared/utils";
import { useWebContext } from "~/app/composables/webContext";

type Props = {
  awayTeam?: Team;
  homeTeam?: Team;
  extraCardTeamIds?: string;
};

defineProps<Props>();

const { webContext } = useWebContext();
</script>

<template>
  <div class="events-teams">
    <div class="relative">
      <img
        v-if="extraCardTeamIds && extraCardTeamIds.split(',').some(id => id === homeTeam?.id.toString())"
        :src="`/img/secret-card/extra-card-${webContext}.png`"
        alt="Secret Card"
        class="w-5 h-auto absolute ltr:right-full rtl:left-full rtl:md:right-full md:left-full inline-block top-1/2 -translate-y-1/2 ms-0.5"
      />
      <NuxtImg
        v-if="homeTeam?.logo.url"
        :src="setAliasUrl(homeTeam.logo?.url)"
        :alt="homeTeam?.name || ''"
        height="42"
        width="42"
        class="team-logo"
      />
    </div>
    <div>vs</div>
    <div class="relative">
      <NuxtImg
        v-if="awayTeam?.logo?.url"
        :src="setAliasUrl(awayTeam.logo.url)"
        :alt="awayTeam?.name || ''"
        height="42"
        width="42"
        class="team-logo"
      />
      <img
        v-if="extraCardTeamIds && extraCardTeamIds.split(',').some(id => id === awayTeam?.id.toString())"
        :src="`/img/secret-card/extra-card-${webContext}.png`"
        alt="Secret Card"
        class="w-5 h-auto absolute ltr:left-full rtl:right-full inline-block top-1/2 -translate-y-1/2 ms-0.5"
      />
    </div>
  </div>
</template>

<style scoped>
.events-teams {
  @apply flex md:flex-col items-center gap-2 md:gap-1 max-w-[130px] md:max-w-[40px];
}

.team-logo {
  @apply w-11 h-11 max-w-11 max-h-11 object-contain object-center inline-block;
}
</style>
